var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "decision-model" }, [
    !_vm.dataLoaded
      ? _c("div", [_vm._v(_vm._s(_vm.$t("loading")))])
      : _c(
          "div",
          [
            _c("div", { staticClass: "flex-row pt-2 pl-2" }, [
              _c("div", { staticClass: "category" }, [
                _vm._v(_vm._s(this.decisionData.modelOutput)),
              ]),
            ]),
            _vm._l(_vm.decisionData.data, function (decision, decisionIndex) {
              return _c(
                "div",
                {
                  key: decisionIndex,
                  staticClass: "flex-row header mt-3 mb-2 mr-5 ml-5",
                },
                [
                  decision
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "flex-col flex-1 flex-justify-center pl-3",
                        },
                        [_vm._v(_vm._s(decision.output))]
                      )
                    : _vm._e(),
                  decision
                    ? _c("div", { staticClass: "flex-col flex-3 mt-2 mb-2" }, [
                        _c("div", { staticClass: "flex-row flex-1 mb-2" }, [
                          _vm._v(_vm._s(decision.compoundCriteria)),
                        ]),
                        decision.compoundChild
                          ? _c(
                              "div",
                              { staticClass: "flex-row flex-1" },
                              [
                                _c("decision-group", {
                                  attrs: { criteria: decision.compoundChild },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        decision.topLevelCriteria !== null
                          ? _c(
                              "div",
                              _vm._l(
                                decision.topLevelCriteria,
                                function (subDecision, subDecisionIndex) {
                                  return _c(
                                    "div",
                                    {
                                      key: subDecisionIndex,
                                      staticClass: "pl-0 mt-2",
                                    },
                                    [
                                      _c("decision-criterion", {
                                        attrs: { criteriaModel: subDecision },
                                      }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]
              )
            }),
          ],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }